import React from 'react';
import { Link } from '@kl/components-v6';
import { LinkProps } from '@kl/components-v6/src/link/types';
import { Locale, LocaleProps } from 'shared/ui/locale';

interface LocalizedLinkProps extends LinkProps, Pick<LocaleProps, 'params'> {
    localizationKey: string;
}

export const LocalizedLink: React.FC<LocalizedLinkProps> = ({
    params = [],
    localizationKey,
    color,
    ...restLinkProps
}) => (
    <Link {...restLinkProps}>
        <Locale localizationKey={localizationKey} params={params} />
    </Link>
);
